module.exports = __webpack_public_path__ + "fonts/6ae2a2f.woff";